import React from "react";
import { TbDownload, TbFileCertificate } from "react-icons/tb";
import LogoNT from "../public/assets/img/National_Telecom_Logo.png";
import Logo from "../public/assets/img/NTLogo.png";
import ApplicationFormPreview from "../public/assets/img/application-form-preview.png";
import RevokeFormPreview from "../public/assets/img/revoke-form-preview.png";

const policyDocuments = [
  {
    title:
      "แนวนโยบายของผู้ให้บริการออกใบรับรองอิเล็กทรอนิกส์ NT CA (CP Version 1.1)",
    englishTitle: "NT Certification Authority Certificate Policy",
    href: "/documents/ntca_cp.pdf",
  },
  {
    title:
      "แนวปฏิบัติของผู้ให้บริการออกใบรับรองอิเล็กทรอนิกส์ NT CA (CPS Version 1.1)",
    englishTitle: "NT Certification Authority Certification Practice Statement",
    href: "/documents/ntca_cps.pdf",
  },
];

const applicationDocuments = [
  {
    title: "คำขอใช้บริการ/สัญญาใช้บริการ NT CA (Subordinate NRCA)",
    englishTitle: "Service Application/Agreement for NT CA",
    version: "Version 1.0",
    href: "/documents/ntca-application-v1.0.pdf",
    preview: ApplicationFormPreview,
  },
  {
    title: "คำขอเพิกถอน บริการ NT CA (Subordinate NRCA)",
    englishTitle: "Revoke Application for NT CA",
    version: "Version 1.0",
    href: "/documents/ntca-revoke-v1.0.pdf",
    preview: RevokeFormPreview,
  },
];

const certificates = [
  {
    generation: "G2",
    href: "/certs/ntcag2.cer",
    filename: "ntcag2.cer",
    thumbprint: "15faa6e924fb02b9e12af12b640eb8a730d6597f",
    subjectKeyIdentifier: "17b1fe8741efebcaa35d9abcabaecf4f1c66a976",
  },
  {
    generation: "G3",
    href: "/certs/ntcag3.cer",
    filename: "ntcag3.cer",
    thumbprint: "adb5a7ba9f9ed6300ed7e3fe31aefcfeda9f33dd",
    subjectKeyIdentifier: "2bcecde5948749a568193932c1c008c30c9285a6",
  },
];

function PolicyCard({ title, englishTitle, href }) {
  return (
    <a
      href={href}
      download
      className="group grid overflow-hidden rounded-2xl border border-amber-100 bg-white shadow-lg shadow-amber-100 transition hover:-translate-y-1 hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-amber-300 sm:grid-cols-[220px_1fr]"
      aria-label={`ดาวน์โหลด ${title}`}
    >
      <div className="flex min-h-64 flex-col items-center justify-center bg-slate-50 p-8 text-center">
        <img src={LogoNT} alt="NT" className="h-auto w-32" />
        <p className="mt-7 text-sm font-semibold text-slate-700">
          {englishTitle}
        </p>
      </div>
      <div className="flex items-center justify-between gap-5 p-7">
        <p className="text-lg font-semibold leading-8 text-slate-900">
          {title}
        </p>
        <TbDownload
          aria-hidden="true"
          className="h-9 w-9 shrink-0 text-amber-500 transition group-hover:translate-y-1"
        />
      </div>
    </a>
  );
}

function ApplicationCard({ title, englishTitle, version, href, preview }) {
  return (
    <a
      href={href}
      download
      className="group overflow-hidden rounded-2xl border border-amber-100 bg-white shadow-lg shadow-amber-100 transition hover:-translate-y-1 hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-amber-300"
      aria-label={`ดาวน์โหลด ${title} ${version}`}
    >
      <div className="flex h-[420px] items-start justify-center overflow-hidden bg-slate-100 p-5">
        <img
          src={preview}
          alt={`ตัวอย่างหน้าแรก ${title}`}
          className="h-full w-auto rounded border border-slate-200 object-contain shadow-md"
        />
      </div>
      <div className="flex items-start justify-between gap-5 p-7">
        <div>
          <h3 className="text-xl font-bold leading-8 text-slate-900">
            {title}
          </h3>
          <p className="mt-2 text-slate-600">{englishTitle}</p>
          <p className="mt-3 font-semibold text-amber-600">{version}</p>
        </div>
        <TbDownload
          aria-hidden="true"
          className="mt-1 h-9 w-9 shrink-0 text-amber-500 transition group-hover:translate-y-1"
        />
      </div>
    </a>
  );
}

function CertificatePanel({ certificate }) {
  const { generation, href, filename, thumbprint, subjectKeyIdentifier } =
    certificate;

  return (
    <article className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
      <h3 className="px-5 py-4 text-center text-lg font-semibold">
        ผู้ให้บริการออกใบรับรองอิเล็กทรอนิกส์ NT CA (NT Certification Authority
        - {generation})
      </h3>
      <div className="overflow-x-auto">
        <div className="min-w-[620px]">
          <div className="grid grid-cols-4 bg-[#ffc107] text-center font-semibold">
            <div className="border border-amber-500 px-3 py-3">
              ผู้ให้บริการ
            </div>
            <div className="border border-amber-500 px-3 py-3">
              วันเริ่มใช้งาน
            </div>
            <div className="border border-amber-500 px-3 py-3">วันหมดอายุ</div>
            <div className="border border-amber-500 px-3 py-3">ดาวน์โหลด</div>
          </div>
          <div className="grid grid-cols-4 text-center">
            <div className="flex h-24 items-center justify-center border p-3">
              <img src={Logo} alt="NT CA" className="h-auto w-20" />
            </div>
            <div className="flex h-24 items-center justify-center border p-3">
              01 พฤศจิกายน 2567
            </div>
            <div className="flex h-24 items-center justify-center border p-3">
              01 พฤศจิกายน 2587
            </div>
            <div className="flex h-24 items-center justify-center border p-3">
              <a
                href={href}
                download={filename}
                aria-label={`ดาวน์โหลดใบรับรอง NT CA ${generation}`}
                className="rounded-md p-2 text-slate-800 hover:bg-amber-100 focus:outline-none focus:ring-4 focus:ring-amber-300"
              >
                <TbFileCertificate aria-hidden="true" className="h-9 w-9" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <dl className="break-all px-5 py-4 text-sm leading-6">
        <div>
          <dt className="inline font-semibold">Thumbprint Algorithm:</dt>{" "}
          <dd className="inline">SHA1</dd>
        </div>
        <div>
          <dt className="inline font-semibold">Thumbprint:</dt>{" "}
          <dd className="inline">{thumbprint}</dd>
        </div>
        <div>
          <dt className="inline font-semibold">Subject key identifier:</dt>{" "}
          <dd className="inline">{subjectKeyIdentifier}</dd>
        </div>
      </dl>
    </article>
  );
}

function Document() {
  return (
    <main className="bg-white px-5 pb-16 pt-12 text-slate-900 md:px-8">
      <div className="mx-auto max-w-7xl">
        <header className="text-center">
          <h1 className="inline-block border-b-4 border-yellow-300 pb-2 text-4xl font-bold md:text-5xl">
            เอกสารเผยแพร่
          </h1>
        </header>

        <section aria-labelledby="policy-heading" className="mt-16">
          <div className="text-center">
            <h2 id="policy-heading" className="text-3xl font-bold">
              นโยบายและแนวปฏิบัติ
            </h2>
            <p className="mt-3 text-lg text-slate-600">
              Latest Update <time dateTime="2025-08-25">25-08-2025</time>
            </p>
          </div>
          <div className="mt-9 grid gap-8 lg:grid-cols-2">
            {policyDocuments.map((document) => (
              <PolicyCard key={document.href} {...document} />
            ))}
          </div>
        </section>

        <section aria-labelledby="application-heading" className="mt-20">
          <h2
            id="application-heading"
            className="text-center text-3xl font-bold"
          >
            แบบคำขอใช้บริการ
          </h2>
          <div className="mt-9 grid gap-8 md:grid-cols-2">
            {applicationDocuments.map((document) => (
              <ApplicationCard key={document.href} {...document} />
            ))}
          </div>
        </section>

        <hr className="my-20 border-slate-200" />

        <section aria-labelledby="certificates-heading">
          <h2
            id="certificates-heading"
            className="text-center text-3xl font-bold md:text-4xl"
          >
            รายการใบรับรองอิเล็กทรอนิกส์
          </h2>
          <div className="mt-9 grid gap-8 xl:grid-cols-2">
            {certificates.map((certificate) => (
              <CertificatePanel
                key={certificate.generation}
                certificate={certificate}
              />
            ))}
          </div>

          <div className="mt-10 flex flex-wrap justify-center gap-x-2 gap-y-3 text-center">
            <span>รายการใบรับรองที่ยกเลิก (CRL)</span>
            <a
              href="/crls/NTCAG2.crl"
              download="NTCAG2.crl"
              className="text-blue-600 underline-offset-4 hover:underline focus:outline-none focus:ring-2 focus:ring-blue-300"
            >
              NT Certification Authority - G2
            </a>
            <span>,</span>
            <a
              href="/crls/NTCAG3.crl"
              download="NTCAG3.crl"
              className="text-blue-600 underline-offset-4 hover:underline focus:outline-none focus:ring-2 focus:ring-blue-300"
            >
              NT Certification Authority - G3
            </a>
          </div>
        </section>
      </div>
    </main>
  );
}

export default Document;
